// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/** English UI strings: Messages from non-component code (workspace/*.ts, lib/*.ts). Merged into the catalog by messages.en.ts. */
export const notices = {
  "notices.command.new-note": "New note",
  "notices.command.new-folder": "New folder",
  "notices.command.share-note": "Share note…",
  "notices.command.command-palette": "Open command palette",
  "notices.command.quick-switcher": "Open quick switcher",
  "notices.command.import": "Import notes (Obsidian, Notion, Markdown)",
  "notices.command.vault-settings": "Vault settings",
  "notices.command.daily-note": "Open today's daily note",
  "notices.command.comment": "Comment on selection",
  "notices.command.insert-template": "Insert template",
  "notices.command.rename-note": "Rename current note",
  "notices.command.duplicate-note": "Duplicate current note",
  "notices.command.delete-note": "Delete current note",
  "notices.command.publish": "Publish note…",
  "notices.command.version-history": "Show version history",
  "notices.command.split-right": "Split right",
  "notices.command.close-tab": "Close tab",
  "notices.command.next-tab": "Next tab",
  "notices.command.previous-tab": "Previous tab",
  "notices.command.close-pane": "Close pane",
  "notices.command.show-files": "Show files",
  "notices.command.search": "Search in vault",
  "notices.command.graph-view": "Open graph view",
  "notices.command.mcp": "MCP (connect AI tools)",
  "notices.command.local-graph": "Show local graph",
  "notices.command.show-tags": "Show tags",
  "notices.command.show-backlinks": "Show backlinks",
  "notices.command.show-outline": "Show outline",
  "notices.command.toggle-left": "Toggle left sidebar",
  "notices.command.toggle-right": "Toggle right sidebar",
  "notices.command.sync-now": "Sync now",
  "notices.command.toggle-vim": "Toggle Vim key bindings",
  "notices.command.toggle-live-preview": "Toggle live preview",
  "notices.command.toggle-full-width": "Toggle full width",
  "notices.command.toggle-mono-font": "Toggle monospaced font",

  "notices.live.unavailable": "Live editing is unavailable; your changes sync normally.",
  "notices.live.offline": "You are offline; your changes are kept on this device and sync when you reconnect.",
  "notices.live.forbidden": "You no longer have access to edit this note live.",
  "notices.live.deleted": "This note was deleted.",
  "notices.live.someone": "Someone",

  "notices.move.exists": "“{path}” already exists.",
  "notices.move.folderName": "Enter a folder name.",
  "notices.move.badName": "A name can't contain any of these characters: {chars}",
  "notices.move.folderClash": "“{path}” already has a file of that name.",

  "notices.desktop.cliFailed": "The command line tool could not be installed: {error}",
  "notices.desktop.upToDate": "Granite {version} is the latest version.",
  "notices.desktop.updateReady": "Granite {version} is available. Install it and restart now?",
  "notices.desktop.updateFailed": "Could not check for updates: {error}",
  "notices.desktop.signInFailed": "Signing in did not finish: {error}",
} as const;
